var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "commonFeedback" } },
    [
      _c(
        "van-popup",
        {
          attrs: { closeable: "", round: "" },
          model: {
            value: _vm.showFeedback,
            callback: function ($$v) {
              _vm.showFeedback = $$v
            },
            expression: "showFeedback",
          },
        },
        [
          _vm.loading
            ? _c("commonTouchLoading")
            : _c(
                "div",
                [
                  _c("p", [_vm._v("Feedback")]),
                  _c(
                    "div",
                    { staticClass: "describe" },
                    [
                      _vm._v(" Describe the problem encountered "),
                      _c("van-field", {
                        staticClass: "textareaField",
                        attrs: {
                          rows: "4",
                          placeholder: "Please Enter",
                          type: "textarea",
                          maxlength: "200",
                          "show-word-limit": "",
                          autosize: "",
                        },
                        model: {
                          value: _vm.content,
                          callback: function ($$v) {
                            _vm.content = $$v
                          },
                          expression: "content",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "common-btn",
                    { staticClass: "btn", attrs: { click: _vm.submit } },
                    [_vm._v("Submit")]
                  ),
                  _c("p", { staticClass: "describe" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.list.showChannel === "phone"
                            ? "You can also call customer service directly"
                            : "You Can Also Contact Us Through The Email, and feedback with your name, phone number and app name :"
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "info" }, [
                    _c("p", { staticClass: "text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.list.showChannel === "phone"
                              ? _vm.list.phone
                              : _vm.list.email
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "p",
                      {
                        staticClass: "copy",
                        attrs: {
                          id: "copy",
                          "data-clipboard-text":
                            _vm.list.showChannel === "phone"
                              ? _vm.list.phone
                              : _vm.list.email,
                        },
                        on: { click: _vm.copy },
                      },
                      [_vm._v(" Copy ")]
                    ),
                  ]),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }